import { useEffect } from "react";
import { createVessels, drawVessels } from "@/vessels";

export const useCanvasEffect = (canvasRef, effect, pressureRef, speedRef, fishRef) => {
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const fishCanvas = fishRef.current;
    const fctx = fishCanvas.getContext("2d");
    let state, raf, vessels;
    let last = performance.now(), t = 0, p = 0;
    const resize = () => {
      canvas.width = fishCanvas.width = window.innerWidth;
      canvas.height = fishCanvas.height = window.innerHeight;
      ctx.fillStyle = "#0a0a0c";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      fctx.clearRect(0, 0, canvas.width, canvas.height);
      state = effect.init(canvas.width, canvas.height);
      vessels = createVessels(canvas.width, canvas.height);
    };
    const loop = (now) => {
      const dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      p += (pressureRef.current - p) * 0.04;
      const k = 0.4 * speedRef.current * (1 + p * 1.5);
      t += dt * k;
      const kf = k * dt * 60;
      fctx.globalCompositeOperation = "destination-out";
      fctx.fillStyle = "rgba(0,0,0,0.12)";
      fctx.fillRect(0, 0, fishCanvas.width, fishCanvas.height);
      effect.draw(ctx, canvas.width, canvas.height, t, state, p, kf, fctx);
      drawVessels(fctx, vessels, canvas.width, canvas.height, t, p, kf);
      raf = requestAnimationFrame(loop);
    };
    resize();
    window.addEventListener("resize", resize);
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [canvasRef, effect, pressureRef, speedRef, fishRef]);
};
